import { AppLog } from "services";
import { StatusMsg } from "utils";
import { Service } from "utils/services";
import { create } from "zustand";
import { postSubmitComment } from "api-function/postContentApi";
import { MessageType } from "utils/enum/message_type";
import socket from "services/socket";

interface ProfilePostContentState {
  post: any;
  comments: any[];

  setComments: (comments: any[]) => void;
  commentSocket: () => void;
  onUpdateReactionLike: (comments: any[], targetId: string, newSubComment: any) => any[];
  onAddOrUpdateSubComment(comments: any[], targetId: string, headerId: string, newSubComment: any, addNew: boolean): any[];
  requestSubmitComment: (sticker: any, textComment: string) => Promise<void>;
}
export const profilePostContentStore = create<ProfilePostContentState>((set, get) => ({
  post: {},
  comments: [],

  setComments: (newComments) => set({ comments: newComments }),

  onUpdateReactionLike: (comments: any[], targetId: string, newSubComment: any) => {
    return comments.map((comment: any) => {
      if (comment.comment_id.toString() === targetId) {
        return {
          ...comment,
          is_like: newSubComment["is_like"],
          key_remove_id: newSubComment["key_remove_id"],
        };
      }
      if (comment.sub_comments?.data?.length) {
        return {
          ...comment,
          sub_comments: {
            ...comment.sub_comments,
            data: get().onUpdateReactionLike(comment.sub_comments.data, targetId, newSubComment),
          },
        };
      }
      return comment;
    });
  },

  requestSubmitComment: async (sticker: any, textComment: string) => {
    const { post, comments } = get();
    try {
      const commentType = Object.keys(sticker).length === 0 ? MessageType.text.value : MessageType.sticker.value;
      const comment = {
        user_id: post?.user_id,
        reply_comment_id: "",
        comment: textComment,
        comment_type: commentType,
        comment_url: Object.keys(sticker).length === 0 ? "" : sticker.thumbnail_url,
        post_id: post?.provider_post_id.toString(),
        attachment_id: post?.post_attachments[0].attachment_id.toString(),
        key_remove_id: await Service.getSynchID(),
      };
      const tmpComment = {
        id: 0,
        is_sending: true,
        user_id: Service?.userAuth["id"].toString(),
        sender: {
          id: Service?.userAuth["id"].toString(),
          email: Service?.userAuth["email"].toString(),
          username: Service?.userAuth["username"].toString(),
          name: Service?.userAuth["name"].toString(),
          gender: Service?.userAuth["gender"].toString(),
          picture: Service?.userAuth["picture"].toString(),
          thumbnail: Service?.userAuth["thumbnail"].toString(),
        },
        reply_comment_id: comment["reply_comment_id"],
        comment: comment["comment"],
        comment_datetime: new Date().toISOString(),
        sending: true,
        key_remove_id: comment["key_remove_id"],
      };
      let newComments = [...comments];
      newComments.unshift(tmpComment);
      set({ comments: [...newComments] });
      const result = await postSubmitComment({ comment: comment });
      if (result.status === StatusMsg.success.value) {
      } else {
        AppLog.show({
          message: `Error ${result["msg"]}`,
          status: StatusMsg.success,
        });
      }
    } catch (err) {
      AppLog.show({
        message: `Error Catch postSubmitcomment ${err}`,
        status: StatusMsg.error,
      });
    }
  },

  commentSocket: () => {
    socket.on("onFlipFlopComment", (result: any) => {
      const { comments, post } = get();

      let tmpComments = [...comments];
      let tmpPost = { ...post };

      const postComments = [...result["post_comments"]];

      if (result["flag"] === "added") {
        postComments.forEach((postComment) => {
          if (post.provider_post_id.toString() === postComment["post_id"]?.toString()) {
            const keyRemoveId = postComment["key_remove_id"]?.toString();
            const replyCommentId = postComment["reply_comment_id"]?.toString();
            if (replyCommentId === "0" || replyCommentId === "") {
              const index = tmpComments.findIndex((item: any) => item["key_remove_id"]?.toString() === keyRemoveId);
              if (index !== -1) {
                tmpComments[index] = { ...postComment };
              } else {
                tmpComments = [postComment, ...tmpComments];
              }
              tmpPost.comments.data = [...tmpComments];
              console.log("=============== post : 1 ===========");
              set({ comments: tmpComments, post: tmpPost });
            } else {
              const resposeComment = postComment;
              const updateResponseComment = get().onAddOrUpdateSubComment(tmpComments, replyCommentId, keyRemoveId, resposeComment, false);
              tmpPost.comments.data = [...tmpComments];
              console.log("=============== post : 2 ===========");
              set({ comments: updateResponseComment, post: tmpPost });
            }
          }
        });
      } else if (result["flag"] === "liked") {
        if (result["reaction_user_id"]?.toString() === Service.userAuth["id"].toString()) {
          const updatedComments = get().onUpdateReactionLike(tmpComments, result["comment_id"], postComments[0]);
          tmpComments = updatedComments;
          tmpPost.comments.data = [...tmpComments];
          console.log("=============== post : 3 ===========");
          set({ comments: updatedComments, post: tmpPost });
        } else {
          console.log("No target");
        }
      }
    });
  },

  onAddOrUpdateSubComment(comments: any[], targetId: string, headerId: string, newSubComment: any, addNew: boolean): any[] {
    return comments.map((comment: any) => {
      if (comment.id.toString() === targetId) {
        if (!comment.sub_comments || !comment.sub_comments.data) {
          return {
            ...comment,
            sub_comments: {
              data: [newSubComment],
            },
          };
        }
        const tmpSubComment = [...comment.sub_comments.data];
        const index = tmpSubComment.findIndex((item: any) => item["key_remove_id"]?.toString() === headerId);
        if (index !== -1) {
          tmpSubComment[index] = {
            ...tmpSubComment[index],
            ...newSubComment,
          };
          return {
            ...comment,
            sub_comments: {
              ...comment.sub_comments,
              data: tmpSubComment,
            },
          };
        } else {
          return {
            ...comment,
            sub_comments: {
              ...comment.sub_comments,
              data: [newSubComment, ...tmpSubComment],
            },
          };
        }
      }
      if (comment.sub_comments?.data?.length) {
        return {
          ...comment,
          sub_comments: {
            ...comment.sub_comments,
            data: get().onAddOrUpdateSubComment(comment.sub_comments.data, targetId, headerId, newSubComment, addNew),
          },
        };
      }

      return comment;
    });
  },
}));

// * ------ OLD CODE ------- * //

// import { AppLog,  AppLog } from "services";
// import { AppRecordJK, AppRecordStatusJK, RequestApi, RouteApi, RouteUrl, StatusMsg } from "utils";
// import { Service } from "utils/services";
// import { create } from "zustand";
// import { NavigateFunction } from "react-router-dom";
// import { requestSubmitFollowingUser, requestSubmitUnFollowinguUser } from "api-function/requestFriendStatusApi";
// import { getComments, getSubComments, onPostReaction, postReactionComment, postSubmitComment, submitRepostContent } from "api-function/postContentApi";
// import socket from "services/socket";
// import { MessageType } from "utils/enum/message_type";
// import { PostReaction } from "models/postReaction";
// import { any } from "zod";
// import { Snackbar } from "components";

// interface ProfilePostContentState {
//   posts: any[];
//   post: any;
//   postsState: AppRecordJK;
//   comments: any[];
//   setComments: (comments: any[]) => void;
//   commentState: AppRecordJK;
//   prePostId: string;
//   currentIndex: number;
//   direction: string;
//   providerPostId: string;
//   userPost: any;

//   initializePage: (params: { postId: string; currentPostId: string }) => Promise<void>;
//   fetchProfilePostContent: (params: { postId: string; currentPostId: string; direction?: string; isRefresh?: boolean }) => Promise<void>;
//   onHandleUp: (navigate: NavigateFunction, currentPostId: string) => void;
//   onHandleDown: (navigate: NavigateFunction) => Promise<void>;
//   onFindPost: (id: string) => Promise<void>;
//   onUpdatePosts: (result: any, userId: string, id: string) => Promise<void>;
//   requestUnFollowing: (id: string) => Promise<void>;
//   requestFollowing: (id: string) => Promise<void>;
//   fetchComments: () => Promise<void>;
//   commentSocket: () => void;
//   onClickedShare: (post: any) => Promise<void>;
//   requestReplyComment: ({
//     replyId,
//     replyText,
//     headerId,
//     commentId,
//     commentUrl,
//   }: {
//     replyId: string;
//     replyText: string;
//     headerId: string;
//     commentId: string;
//     commentUrl: string;
//   }) => Promise<void>;

//   onUpdateReactionLike: (comments: any[], targetId: string, newSubComment: any) => any[];
//   onAddOrUpdateSubComment(comments: any[], targetId: string, headerId: string, newSubComment: any, addNew: boolean): any[];
//   requestReactionComment: (comment: any) => Promise<void>;
//   requestSubmitComment: (sticker: any, textComment: string) => Promise<void>;
//   fetchSubComments: (commentId: string, nextPageUrl?: string) => Promise<void>;
//   requestPostReactionClicked: ({
//     liked,
//     shared,
//     content,
//     attachment,
//     postReaction,
//   }: {
//     liked?: boolean;
//     shared?: boolean;
//     content: any;
//     attachment: any;
//     postReaction: PostReaction;
//   }) => Promise<void>;
//   requestShare: (shareText: string) => Promise<void>;
// }
// export const profilePostContentStore = create<ProfilePostContentState>((set, get) => ({
//   userPost: {},
//   providerPostId: "",
//   direction: "",
//   currentIndex: 0,
//   prePostId: "",
//   posts: [],
//   post: {},
//   postsState: new AppRecordJK({ loadingStatus: AppRecordStatusJK.loading }),
//   comments: [],
//   setComments: (newComments) => set({ comments: newComments }),
//   commentState: new AppRecordJK({ loadingStatus: AppRecordStatusJK.loaded }),

//   initializePage: async ({ postId, currentPostId }: { postId: string; currentPostId: string }) => {
//     try {
//       // console.log("-----post_id ", postId);
//       set({ currentIndex: 0 });
//       profilePostContentStore.getState().fetchProfilePostContent({
//         postId: postId,
//         currentPostId: currentPostId,
//         isRefresh: true,
//       });
//     } catch (error) {
//       console.log("-----post_id ", postId);
//        AppLog.show({
//         message: `[initializePage]`,
//         status: StatusMsg.error,
//         error,
//       });
//     }
//   },

//   onHandleDown: async (navigate) => {
//     const { currentIndex, posts } = get();
//     if (currentIndex > 0) {
//       let tmpIndex = currentIndex - 1;
//       set({ direction: "up", currentIndex: tmpIndex });

//       navigate(`${RouteUrl.profilePostContentsPageView}?post_id=${posts[tmpIndex].post_id}`, { replace: true });
//     }
//   },

//   onHandleUp: async (navigate, currentPostId) => {
//     const { currentIndex, posts, direction } = get();

//     if (currentIndex < posts.length - 1) {
//       let tmpIndex = currentIndex + 1;

//       set({ direction: "down", currentIndex: tmpIndex });

//       navigate(`${RouteUrl.profilePostContentsPageView}?post_id=${posts[tmpIndex].post_id}`, { replace: true });

//       if (tmpIndex === posts.length - 1) {
//         const postId = posts[posts.length - 1].post_id;

//         profilePostContentStore.getState().fetchProfilePostContent({
//           isRefresh: false,
//           postId: postId,
//           currentPostId: currentPostId,
//           direction: direction,
//         });
//       }
//     }
//   },

//   onFindPost: async (id: string) => {
//     const { posts } = get();
//     const tmpCommentState = new AppRecordJK({
//       loadingStatus: AppRecordStatusJK.loaded,
//     });
//     try {
//       const tmpPost = posts.find((post) => post.post_id === id);

//       if (tmpPost) {
//         if (tmpPost.comments["next_page_url"]) {
//           tmpCommentState.nextPageUrl = tmpPost.comments["next_page_url"];
//           tmpCommentState.loadingStatus = AppRecordStatusJK.loaded;
//         } else {
//           tmpCommentState.nextPageUrl = "";
//           tmpCommentState.loadingStatus = AppRecordStatusJK.noLoadMore;
//         }

//         set({
//           userPost: tmpPost.re_post_user ? tmpPost.re_post_user : tmpPost.user,
//           providerPostId: tmpPost.provider_post_id,
//           post: tmpPost,
//           prePostId: tmpPost?.post_id.toString(),
//           comments: tmpPost.comments.data,
//           commentState: tmpCommentState,
//         });
//       }
//     } catch (err) {
//        AppLog.show({
//         message: `catch findPost ${err}`,
//         status: StatusMsg.error,
//       });
//     }
//   },

//   fetchProfilePostContent: async ({
//     postId,
//     currentPostId,
//     direction = "",
//     isRefresh = false,
//   }: {
//     postId: string;
//     currentPostId: string;
//     direction?: string;
//     isRefresh?: boolean;
//   }): Promise<void> => {
//     const { posts } = get();
//     const tmpAppRecord = new AppRecordJK({
//       loadingStatus: AppRecordStatusJK.loaded,
//     });
//     const tmpCommentState = new AppRecordJK({
//       loadingStatus: AppRecordStatusJK.loaded,
//     });
//     try {
//       if (isRefresh) {
//         tmpAppRecord.loadingStatus = AppRecordStatusJK.loading;
//         tmpAppRecord.nextPageUrl = "";
//       } else {
//         if (tmpAppRecord.canLoadMore()) {
//           tmpAppRecord.loadingStatus = AppRecordStatusJK.loadingMore;
//         } else {
//           return;
//         }
//       }
//       set({ postsState: tmpAppRecord });
//       let url: string = "";
//       if (Service.isAuthenticated) {
//         url = RouteApi.getHomeProfilePost;
//         url += `token=${Service.token}`;
//       } else {
//         url = RouteApi.getProfilePostContentsPageView;
//       }
//       const response = await RequestApi(url, {
//         data: { post_id: postId, direction: direction },
//       });
//       if (response.status === "success") {
//         let tmpPosts = [];
//         if (response["post"]) {
//           tmpPosts[0] = response["post"];
//         } else {
//           tmpPosts = isRefresh ? [...response["posts"]] : [...posts, ...response["posts"]];
//         }
//         if (isRefresh) {
//           const tmpPost = tmpPosts.find((post) => post.post_id === currentPostId);
//           if (tmpPost) {
//             if (tmpPost.comments["next_page_url"]) {
//               tmpCommentState.nextPageUrl = tmpPost.comments["next_page_url"];
//               tmpCommentState.loadingStatus = AppRecordStatusJK.loaded;
//             } else {
//               tmpCommentState.nextPageUrl = "";
//               tmpCommentState.loadingStatus = AppRecordStatusJK.noLoadMore;
//             }
//             set({
//               userPost: tmpPost.re_post_user ? tmpPost.re_post_user : tmpPost.user,
//               providerPostId: tmpPost.provider_post_id,
//               commentState: tmpCommentState,
//               post: tmpPost,
//               prePostId: tmpPost.post_id.toString(),
//               comments: [...tmpPost.comments.data],
//             });
//           }
//         }
//         tmpAppRecord.loadingStatus = AppRecordStatusJK.loaded;
//         set({ posts: tmpPosts, postsState: tmpAppRecord });
//       } else {
//         tmpAppRecord.loadingStatus = AppRecordStatusJK.loaded;
//         set({
//           postsState: tmpAppRecord,
//         });
//          AppLog.show({
//           message: `[fetchProfilePostContent] ${response["msg"]}`,
//           status: StatusMsg.getType(response["status"]),
//         });
//       }
//     } catch (error) {
//       tmpAppRecord.loadingStatus = AppRecordStatusJK.loaded;
//       set({ postsState: tmpAppRecord });
//        AppLog.show({
//         message: `[fetchProfilePostContent]`,
//         status: StatusMsg.error,
//         error,
//       });
//     }
//   },

//   requestPostReactionClicked: async ({
//     liked,
//     shared,
//     content,
//     attachment,
//     postReaction,
//   }: {
//     liked?: boolean;
//     shared?: boolean;
//     content: any;
//     attachment: any;
//     postReaction: PostReaction;
//   }) => {
//     try {
//       const user = Service?.userAuth;
//       if (user) {
//         if (postReaction === PostReaction.like) {
//           if (liked !== null) {
//             const result = await onPostReaction({
//               content: content,
//               reaction: PostReaction.like,
//               isLike: liked,
//               isFavorite: false,
//               attachment: any,
//             });
//             if (result.status === "success") {
//               const tmposts = { ...content };
//               if (tmposts && tmposts.post_attachments) {
//                 const updatedTmposts = { ...tmposts };
//                 const updatedAttachments = [...updatedTmposts.post_attachments];
//                 const firstAttachment = { ...updatedAttachments[0] };
//                 const likeUsers = [...tmposts["like_users"]];

//                 firstAttachment["is_reaction_like"] = liked ? "1" : "0";
//                 updatedAttachments[0] = firstAttachment;
//                 updatedTmposts.post_attachments = updatedAttachments;

//                 const numberLike = liked ? 1 : -1;
//                 updatedTmposts.reaction_like_count = (Number(updatedTmposts.reaction_like_count) || 0) + numberLike;
//                 let tmpLikeUsers = [];
//                 if (liked) {
//                   const userAuth = {
//                     id: user["id"]?.toString(),
//                     picture: user["picture"]?.toString(),
//                     thumbnail: user["thumbnail"]?.toString(),
//                     avatar: user["avatar"]?.toString(),
//                   };

//                   tmpLikeUsers = [...likeUsers, ...[userAuth]];
//                   updatedTmposts.like_users = tmpLikeUsers;
//                 } else {
//                   tmpLikeUsers = [...likeUsers];
//                   const index = tmpLikeUsers.findIndex((item) => item["id"]?.toString() === user["id"]?.toString());

//                   if (index !== -1) {
//                     tmpLikeUsers.splice(index, 1);
//                     updatedTmposts.like_users = tmpLikeUsers;
//                   }
//                 }
//                 set({ post: { ...updatedTmposts } });
//               }
//             } else {
//               console.log("message error :" + result["msg"]);
//             }
//           }
//         } else if (postReaction === PostReaction.favorite) {
//           let favorite = attachment["is_reaction_favorite"].toString() === "1" ? false : true;
//           const result = await onPostReaction({
//             content: content,
//             reaction: PostReaction.favorite,
//             isLike: false,
//             isFavorite: favorite,
//             attachment: any,
//           });
//           if (result.status === "success") {
//             const tmposts = { ...content };
//             if (tmposts && tmposts.post_attachments) {
//               const updatedTmposts = { ...tmposts };
//               const updatedAttachments = [...updatedTmposts.post_attachments];
//               const firstAttachment = { ...updatedAttachments[0] }; // Copy the first attachment

//               firstAttachment["is_reaction_favorite"] = favorite ? "1" : "0";
//               updatedAttachments[0] = firstAttachment; // Reassign the modified attachment
//               updatedTmposts.post_attachments = updatedAttachments;

//               const favoriteCount = favorite ? 1 : -1;
//               updatedTmposts.reaction_favorite_count = (Number(updatedTmposts.reaction_favorite_count) || 0) + favoriteCount;
//               set({ post: updatedTmposts });
//             }
//           } else {
//             console.log("message error :" + result["msg"]);
//           }
//         }
//       }
//     } catch (err) {
//       AppLog({ message: `catch onPosreactionClikc ${err}` });
//     }
//   },

//   onClickedShare: async (post: any) => {
//     try {
//       const { posts } = get();
//       const tmpPost = { ...post };

//       const editIndex = posts.findIndex((post) => post.provider_post_id === tmpPost.provider_post_id);
//       if (editIndex !== -1) {
//         set((state) => {
//           const updatedPosts = [...state.posts];
//           updatedPosts[editIndex] = tmpPost;
//           return { posts: updatedPosts };
//         });
//       }
//     } catch (error) {
//        AppLog.show({
//         message: `[onClickedShare]`,
//         status: StatusMsg.error,
//         error,
//       });
//     }
//   },

//   // Friend status
//   requestUnFollowing: async (id: string) => {
//     const { post } = get();
//     const userId = post?.re_post_user !== null ? post?.re_post_user_id?.toString() : post?.user_id?.toString();
//     const result = await requestSubmitUnFollowinguUser({ userId: userId });

//     if (result.status === "success") {
//       profilePostContentStore.getState().onUpdatePosts(result, userId, id);
//     }
//   },

//   requestFollowing: async (id: string) => {
//     const { post } = get();
//     const userId = post?.re_post_user !== null ? post?.re_post_user_id?.toString() : post?.user_id?.toString();
//     const result = await requestSubmitFollowingUser({ userId: userId });
//     if (result.status === "success") {
//       profilePostContentStore.getState().onUpdatePosts(result, userId, id);
//     }
//   },

//   onUpdatePosts: async (result: any, userId: string, id: string) => {
//     const { posts } = get();
//     try {
//       const tmpPosts = posts.map((post) => {
//         const postCopy = { ...post }; // Shallow copy of the post

//         if (post["re_post_user"] !== null && post["re_post_user"] !== undefined) {
//           if (post["re_post_user"]["id"]?.toString() === userId) {
//             postCopy.re_post_user = { ...post.re_post_user };
//             postCopy.re_post_user.friend_status = result?.user?.friend_status || null;
//           }
//         } else if (post["user"] !== null && post["user"] !== undefined) {
//           if (post["user_id"]?.toString() === userId) {
//             postCopy.user = { ...post.user };
//             postCopy.user.friend_status = result?.user?.friend_status || null;
//           }
//         }

//         return postCopy;
//       });
//       const tmpPost = tmpPosts.find((post) => post.post_id === id);
//       set({ post: tmpPost, posts: tmpPosts });
//     } catch (err) {
//       console.log("errr", err);
//     }
//   },

//   // comments
//   fetchComments: async () => {
//     const { comments, commentState, post } = get();
//     const tmpCommentsState = new AppRecordJK({
//       loadingStatus: AppRecordStatusJK.loadingMore,
//     });
//     try {
//       set({ commentState: tmpCommentsState });
//       const nextPage = comments.length === 10 ? "" : commentState.nextPageUrl ?? "";

//       const result = await getComments({
//         postId: post?.provider_post_id,
//         attachmentId: post?.post_attachments[0]["attachment_id"],
//         nextPage: nextPage,
//       });
//       if (result.status === "success") {
//         const tmpComments = [...comments, ...result["comments"]["data"]];
//         if (result["comments"]["next_page_url"]) {
//           tmpCommentsState.nextPageUrl = result["comments"]["next_page_url"];
//           tmpCommentsState.loadingStatus = AppRecordStatusJK.loaded;
//         } else {
//           tmpCommentsState.nextPageUrl = "";
//           tmpCommentsState.loadingStatus = AppRecordStatusJK.noLoadMore;
//         }
//         set({ comments: tmpComments, commentState: tmpCommentsState });
//       } else {
//          AppLog.show({
//           message: `fail to fetch comment ${result["msg"]}`,
//           status: StatusMsg.getType(result["status"]),
//         });
//         tmpCommentsState.loadingStatus = AppRecordStatusJK.loaded;
//         set({ commentState: tmpCommentsState });
//       }
//     } catch (error) {
//       tmpCommentsState.loadingStatus = AppRecordStatusJK.loaded;
//       set({ commentState: tmpCommentsState });
//        AppLog.show({
//         message: `[fetchProfilePostContent]`,
//         status: StatusMsg.error,
//         error,
//       });
//     }
//   },

//   requestReactionComment: async ({ comment }: { comment: any }) => {
//     const { comments } = get();
//     try {
//       let tmpComment = comment;
//       const isLike = tmpComment["is_like"]?.toString() === "0" ? "1" : "0";
//       const data = {
//         comment_id: tmpComment["comment_id"]?.toString(),
//         is_like: isLike,
//         key_remove_id: await Service.getSynchID(),
//       };

//       const updatedComments = get().onUpdateReactionLike(comments, tmpComment["comment_id"].toString(), data);
//       set({ comments: [...updatedComments] });

//       const result = await postReactionComment({ data: data });
//       if (result.status === StatusMsg.success.value) {
//       } else {
//          AppLog.show({
//           message: `Error ${result["msg"]}`,
//           status: StatusMsg.success,
//         });
//       }
//     } catch (err) {
//        AppLog.show({
//         message: `Error Catch requestReactionComment ${err}`,
//         status: StatusMsg.error,
//       });
//     }
//   },

//   onUpdateReactionLike: (comments: any[], targetId: string, newSubComment: any) => {
//     return comments.map((comment: any) => {
//       if (comment.comment_id.toString() === targetId) {
//         return {
//           ...comment,
//           is_like: newSubComment["is_like"],
//           key_remove_id: newSubComment["key_remove_id"],
//         };
//       }
//       if (comment.sub_comments?.data?.length) {
//         return {
//           ...comment,
//           sub_comments: {
//             ...comment.sub_comments,
//             data: get().onUpdateReactionLike(comment.sub_comments.data, targetId, newSubComment),
//           },
//         };
//       }
//       return comment;
//     });
//   },

//   requestReplyComment: async ({
//     replyId,
//     replyText,
//     headerId,
//     commentId,
//     commentUrl,
//   }: {
//     replyId: string;
//     replyText: string;
//     headerId: string;
//     commentId: string;
//     commentUrl: string;
//   }) => {
//     const { post, comments } = get();
//     try {
//       const comment = {
//         user_id: post?.user_id,
//         reply_comment_id: replyId,
//         comment: replyText,
//         comment_type: commentUrl === "" ? MessageType.text.value : MessageType.sticker.value,
//         comment_url: commentUrl,
//         post_id: post?.provider_post_id.toString(),
//         attachment_id: post?.post_attachments[0].attachment_id.toString(),
//         key_remove_id: await Service.getSynchID(),
//       };

//       const tmpSubComment = {
//         id: 0,
//         user_id: Service?.userAuth["id"].toString(),
//         comment_id: commentId,
//         sender: {
//           id: Service?.userAuth["id"].toString(),
//           email: Service?.userAuth["email"].toString(),
//           username: Service?.userAuth["username"].toString(),
//           name: Service?.userAuth["name"].toString(),
//           gender: Service?.userAuth["gender"].toString(),
//           picture: Service?.userAuth["picture"].toString(),
//           thumbnail: Service?.userAuth["thumbnail"].toString(),
//         },
//         reply_comment_id: comment["reply_comment_id"],
//         comment: replyText,
//         comment_datetime: new Date().toISOString(), // Convert date to string
//         sending: true,
//         key_remove_id: comment["key_remove_id"],
//       };
//       const updatedComments = get().onAddOrUpdateSubComment(comments, replyId, headerId, tmpSubComment, true);
//       set({ comments: [...updatedComments] });

//       const result = await postSubmitComment({ comment: comment });
//       if (result.status === StatusMsg.success.value) {
//       } else {
//       }
//     } catch (err) {
//        AppLog.show({
//         message: `ERROR CATCH ${err}`,
//         status: StatusMsg.error,
//       });
//     }
//   },

//   requestShare: async (shareText: string) => {
//     const { post } = get();
//     const result = await submitRepostContent({
//       providerPostId: post?.provider_post_id.toString(),
//       medaiTitle: shareText,
//     });
//     if (result.status === "success") {
//       const tmpost = { ...post };
//       if (tmpost && tmpost.post_attachments) {
//         tmpost.reaction_share_count = (Number(tmpost.reaction_share_count) || 0) + 1;
//         set({ post: tmpost });
//       }
//     } else {
//     }
//   },

//   requestSubmitComment: async (sticker: any, textComment: string) => {
//     const { post, comments } = get();
//     try {
//       const commentType = Object.keys(sticker).length === 0 ? MessageType.text.value : MessageType.sticker.value;
//       const comment = {
//         user_id: post?.user_id,
//         reply_comment_id: "",
//         comment: textComment,
//         comment_type: commentType,
//         comment_url: Object.keys(sticker).length === 0 ? "" : sticker.thumbnail_url,
//         post_id: post?.provider_post_id.toString(),
//         attachment_id: post?.post_attachments[0].attachment_id.toString(),
//         key_remove_id: await Service.getSynchID(),
//       };
//       const tmpComment = {
//         id: 0,
//         is_sending: true,
//         user_id: Service?.userAuth["id"].toString(),
//         sender: {
//           id: Service?.userAuth["id"].toString(),
//           email: Service?.userAuth["email"].toString(),
//           username: Service?.userAuth["username"].toString(),
//           name: Service?.userAuth["name"].toString(),
//           gender: Service?.userAuth["gender"].toString(),
//           picture: Service?.userAuth["picture"].toString(),
//           thumbnail: Service?.userAuth["thumbnail"].toString(),
//         },
//         reply_comment_id: comment["reply_comment_id"],
//         comment: comment["comment"],
//         comment_datetime: new Date().toISOString(),
//         sending: true,
//         key_remove_id: comment["key_remove_id"],
//       };
//       let newComments = [...comments];
//       newComments.unshift(tmpComment);
//       set({ comments: [...newComments] });
//       const result = await postSubmitComment({ comment: comment });
//       if (result.status === StatusMsg.success.value) {
//       } else {
//          AppLog.show({
//           message: `Error ${result["msg"]}`,
//           status: StatusMsg.success,
//         });
//       }
//     } catch (err) {
//        AppLog.show({
//         message: `Error Catch postSubmitcomment ${err}`,
//         status: StatusMsg.error,
//       });
//     }
//   },
//   // sub comment
//   fetchSubComments: async (commentId: string, nextPageUrl?: string) => {
//     const { post, comments } = get();
//     try {
//       const result = await getSubComments({
//         postId: post?.provider_post_id,
//         attachmentId: post?.post_attachments[0]["attachment_id"],
//         replyCommentId: commentId,
//         nextPageUrl: nextPageUrl,
//       });

//       if (result.status === "success") {
//         const fetchedSubComments = {
//           data: [...result["comments"]["data"]],
//           next_page_url: result["comments"]["next_page_url"],
//         };

//         const updateCommentWithSubComments = (comments: any, targetId: string, subComments: any) => {
//           return comments.map((comment: any) => {
//             if (comment.id.toString() === targetId) {
//               const existingSubComments = comment.sub_comments?.data || [];
//               const mergedSubComments = Array.from(new Map([...existingSubComments, ...subComments.data].map((sc) => [sc.id, sc])).values());

//               const updatedSubComments = {
//                 ...subComments,
//                 data: mergedSubComments,
//               };

//               return { ...comment, sub_comments: updatedSubComments };
//             }

//             if (comment.sub_comments?.data?.length) {
//               return {
//                 ...comment,
//                 sub_comments: {
//                   ...comment.sub_comments,
//                   data: updateCommentWithSubComments(comment.sub_comments.data, targetId, subComments),
//                 },
//               };
//             }

//             return comment;
//           });
//         };
//         const updatedComments = updateCommentWithSubComments(comments, commentId, fetchedSubComments);
//         set({ comments: [...updatedComments] });
//       } else {
//          AppLog.show({
//           message: `Failed to fetch sub-comments: ${result["msg"]}`,
//         });
//       }
//     } catch (err) {
//       AppLog({ message: `Error in fetchSubComments: ${err}` });
//     }
//   },
//   // sockect listening
//   commentSocket: () => {
//     socket.on("onFlipFlopComment", (result: any) => {
//       const { comments, post } = get();

//       let tmpComments = [...comments];
//       let tmpPost = { ...post };
//       // console.log("====listen type", result);
//       const postComments = [...result["post_comments"]];

//       if (result["flag"] === "added") {
//         postComments.forEach((postComment) => {
//           if (post.provider_post_id.toString() === postComment["post_id"]?.toString()) {
//             const keyRemoveId = postComment["key_remove_id"]?.toString();
//             const replyCommentId = postComment["reply_comment_id"]?.toString();
//             if (replyCommentId === "0" || replyCommentId === "") {
//               const index = tmpComments.findIndex((item: any) => item["key_remove_id"]?.toString() === keyRemoveId);
//               if (index !== -1) {
//                 tmpComments[index] = { ...postComment };
//               } else {
//                 tmpComments = [postComment, ...tmpComments];
//               }
//               tmpPost.comments.data = [...tmpComments];
//               set({ comments: tmpComments, post: tmpPost });
//             } else {
//               const resposeComment = postComment;
//               const updateResponseComment = get().onAddOrUpdateSubComment(tmpComments, replyCommentId, keyRemoveId, resposeComment, false);
//               tmpPost.comments.data = [...tmpComments];
//               set({ comments: updateResponseComment, post: tmpPost });
//             }
//           }
//         });
//       } else if (result["flag"] === "liked") {
//         if (result["reaction_user_id"]?.toString() === Service.userAuth["id"].toString()) {
//           const updatedComments = get().onUpdateReactionLike(tmpComments, result["comment_id"], postComments[0]);
//           tmpComments = updatedComments;
//           tmpPost.comments.data = [...tmpComments];
//           set({ comments: updatedComments, post: tmpPost });
//         } else {
//           console.log("No target");
//         }
//       }
//     });
//   },

//   onAddOrUpdateSubComment(comments: any[], targetId: string, headerId: string, newSubComment: any, addNew: boolean): any[] {
//     return comments.map((comment: any) => {
//       if (comment.id.toString() === targetId) {
//         if (!comment.sub_comments || !comment.sub_comments.data) {
//           return {
//             ...comment,
//             sub_comments: {
//               data: [newSubComment],
//             },
//           };
//         }
//         const tmpSubComment = [...comment.sub_comments.data];
//         const index = tmpSubComment.findIndex((item: any) => item["key_remove_id"]?.toString() === headerId);
//         if (index !== -1) {
//           tmpSubComment[index] = {
//             ...tmpSubComment[index],
//             ...newSubComment,
//           };
//           return {
//             ...comment,
//             sub_comments: {
//               ...comment.sub_comments,
//               data: tmpSubComment,
//             },
//           };
//         } else {
//           return {
//             ...comment,
//             sub_comments: {
//               ...comment.sub_comments,
//               data: [newSubComment, ...tmpSubComment],
//             },
//           };
//         }
//       }
//       if (comment.sub_comments?.data?.length) {
//         return {
//           ...comment,
//           sub_comments: {
//             ...comment.sub_comments,
//             data: get().onAddOrUpdateSubComment(comment.sub_comments.data, targetId, headerId, newSubComment, addNew),
//           },
//         };
//       }

//       return comment;
//     });
//   },
// }));
